export default __webpack_public_path__ + "assets/favicons/favicon-16x16.png";